import { RootState } from 'store';

export const selectUserIsLoggedIn = (state: RootState) => state.user.isLoggedIn;
